import { FileSyncOutlined, LoadingOutlined } from '@ant-design/icons'
import { Button, Tooltip } from 'antd'

interface ExcelDownloadButtonProps {
  onDownload: () => void
  isLoading: boolean
  tooltip?: string
}

/**
 * Icon-only "Work in Excel" button -- same look as UploadDownloadButtons'
 * Dropdown.Button, for grids that only support downloading (no upload option
 * to pair it with).
 */
export function ExcelDownloadButton({
  onDownload,
  isLoading,
  tooltip = 'Download to Excel',
}: ExcelDownloadButtonProps) {
  return (
    <Tooltip title={tooltip}>
      <Button onClick={onDownload} disabled={isLoading}>
        {isLoading ? (
          <LoadingOutlined style={{ fontSize: '1.2em' }} />
        ) : (
          <FileSyncOutlined style={{ fontSize: '1.2em' }} />
        )}
      </Button>
    </Tooltip>
  )
}
